import { takeEvery, put } from 'redux-saga/effects';
import { tags as tagsActions, flyers as flyersActions } from 'flux/actions';

export function* clearSearch() {
  yield put(tagsActions.search(''));
}

export default function* () {
  yield takeEvery(flyersActions.types.SET_CURRENT_FLYER, clearSearch);
}
